import { DestroyRef, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { removeAllEntities, setAllEntities, withEntities } from '@ngrx/signals/entities';
import { Organization } from '../../../modules/analytics/models/organization';
import { SignalStoreResetRegistry } from '../../../modules/shared/signal-store';

export const OrganizationTreeStore = signalStore(
  { providedIn: 'root' },
  withEntities<Organization>(),
  withState({ loaded: false, loading: false }),
  withProps((store) => ({
    entities$: toObservable(store.entities),
    loading$: toObservable(store.loading),
    hasCache$: toObservable(store.loaded),
  })),
  withMethods((store) => ({
    setAll: (orgs: Organization[]) =>
      patchState(store, setAllEntities([...orgs].sort((a, b) => a.name.localeCompare(b.name))), { loaded: true }),
    setLoading: (loading: boolean) => patchState(store, { loading }),
    resetCache: () => patchState(store, { loaded: false }),
    reset: () => patchState(store, removeAllEntities(), { loaded: false, loading: false }),
    getOperation: (id: string) => {
      for (const org of store.entities()) {
        const op = org.operations.find(y => y.id === id);
        if (op) return op;
      }
      return null;
    }
  })),
  withHooks({
    onInit(store) {
      const registry = inject(SignalStoreResetRegistry);
      const unregister = registry.register(() => store.reset());
      inject(DestroyRef).onDestroy(unregister);
    },
  })
);
